module.exports = __webpack_public_path__ + "static/media/c-dessert.a52c4585.jpg";